import {
  SelectedQuoteSummary,
  type SelectedQuoteSummaryProps,
} from "@/shared/components/SelectedQuoteSummary";

type SelectedCarQuoteSummaryProps = Omit<
  SelectedQuoteSummaryProps,
  "insuredValue" | "insuredValueLabel"
> & {
  carValue?: string | number | null;
};

export function SelectedCarQuoteSummary({ carValue, ...props }: SelectedCarQuoteSummaryProps) {
  return <SelectedQuoteSummary {...props} insuredValue={carValue} insuredValueLabel="Car Value" />;
}
